import cookies from "js-cookie";

const logOut = (): void => {
  cookies.remove("access_token");
  cookies.remove("admin_access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("admin_refresh_token");
  localStorage.removeItem("redirect_url");
};

export default logOut;
